import { useState, useContext } from "react";
import BeneficialOwnershipTab from "components/PLCTABS/BeneficialOwnershipTab";
import UpdateHistoryContext from "context/UpdateHistoryContext";

const BeneficialOwners = ({ handleGoBack, handleGoForward }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { isInUpdateHistoryContext, transactions } =
    useContext(UpdateHistoryContext);

  return (
    <div className="relative mt-2">
      <BeneficialOwnershipTab
        handleBackBtn={handleGoBack}
        handleNextBtn={handleGoForward}
        submitBtnLabel="Save and Proceed"
        isSubmitting={isSubmitting}
        isInUpdateHistoryContext={isInUpdateHistoryContext}
        transactions={transactions}
      />
    </div>
  );
};

export default BeneficialOwners;
